const DEFAULT_LOGIN_ERROR = "Unable to sign in. Please try again.";

function responseMessage(data) {
  if (!data) return "";
  if (typeof data === "string") return data;
  return data.message || data.msg || data.error || data.detail || "";
}

function cleanReason(value) {
  return String(value || "")
    .replace(/^request failed(?:\s+with status code)?\s*:?\s*\d{3}\s*(?:[—–-]\s*)?/i, "")
    .replace(/^request failed\s*:?\s*/i, "")
    .trim();
}

export function getLoginErrorReason(error, fallbackReason = DEFAULT_LOGIN_ERROR) {
  const status = Number(error?.status || error?.response?.status || 0);

  // Keep credential failures generic so login never reveals whether an account exists.
  if (status === 401) return "Invalid email or password.";
  if (status >= 500) return "Unable to sign in right now. Please try again.";

  const rawReason = error?.serverMessage
    || responseMessage(error?.response?.data)
    || error?.message
    || fallbackReason;
  const reason = cleanReason(rawReason);

  if (!reason) return fallbackReason;
  if (/^(invalid credentials|unauthorized)$/i.test(reason)) return "Invalid email or password.";
  if (/^(network error|failed to fetch|load failed)$/i.test(reason)) {
    return "Unable to connect. Check your internet connection and try again.";
  }
  if (/^(invalid login response|login failed\s*[:—–-]?\s*(?:no )?token.*)$/i.test(reason)) {
    return DEFAULT_LOGIN_ERROR;
  }
  return reason;
}

export function getLoginErrorDialogOptions(error, fallbackReason) {
  return {
    icon: "error",
    title: "Login failed",
    text: getLoginErrorReason(error, fallbackReason),
    confirmButtonText: "Try again",
  };
}

export { DEFAULT_LOGIN_ERROR };
